import React from 'react';

/**
 * AppLoader component that matches the initial loader in index.html
 * Uses the same CSS classes and structure for consistency
 */
function AppLoader({ message = "Loading..." }) {
  return (
    <div className="initial-loader">
      <div className="loader-content">
        <div className="loader-message">{message}</div>
        <div className="loader-spinner"></div>
      </div>
    </div>
  );
}

export default AppLoader;
